<template>
  <div>
    <h1>Fiche Rendez-Vous Fournisseur</h1>
    <div id="fiche-cdm-filter-container">
      <div>
        <label>Année de contrat : </label>
        <select class="form-select" v-model="selectedYear">
          <option v-for="year of yearList" :value="year" :key="year">{{year}}</option>
        </select>
      </div>
      <label>Fournisseur : </label>
      <Substitute class="substitute" :frsList="frsList" :selectedFrsGuid="selectedFrsGuid" @update="substitute"></Substitute>
      <!-- Affichage du montant de la facturation dans le template -->
      <label>Avec montant facturation ?</label>
      <div>
        <input type="checkbox" name="WithTarif" v-model="withFacturation" /><span> (coché = Oui)</span>
      </div>
      
    </div>
    <div id="fiche-cdm-content">
      <button class="button-generation" @click="generateExcel" v-if="selectedFrs && $store.state.loader == 0">Générer le fichier</button>
      <strong v-else>Veuillez sélectionner un fournisseur</strong>
    </div>
  </div>
</template>

<script>
  import ExcelJS from "exceljs";
  import { saveAs } from 'file-saver';

  import Substitute from "@/components/Substitute";
  import {
    getFrsList,
    getFrsInfosByYear,
    getFrsLastContactUpdateDate,
    getFrsIntranetRubriques,
    getFrsIntranetDocumentLastDate,
    getFrsVersementsByYear,
    getFrsAppointmentFormData,
    getFrsSimulableInfos
  } from "@/utils/frs";
  import { getCampaignsYear } from "@/utils/period";
  import { logGeneratedFicheRdv } from "@/utils/cdm"
  import { verifyModuleRights } from "@/utils/module";


  export default {
    name: "FicheFrs",
    components: { Substitute },
    data() {
      return {
        frsList: [],
        frsSimulableInfos: {},
        yearList: [],
        selectedFrsGuid: "",
        selectedYear: -1,
        data: {},
        withFacturation: true,
      }
    },
    mounted() {
      // Récupère la liste des fournisseurs complète, puis la liste des campagnes pour initialiser les sélecteurs
      let nbReqEnd = 0;
      getFrsSimulableInfos().then(res => {
        for (let obj of res) {
          this.frsSimulableInfos[obj.Key] = obj.Value;
        }
      })

      new Promise((resolve, reject) => {
        getFrsList().then(res => {
          this.frsList = res
          nbReqEnd += 1;
          if (nbReqEnd == 2) resolve()
        });
        // Défini la dernière année comme active par défaut
        getCampaignsYear().then(years => {
          if (!years) return;
          this.yearList = years;
          nbReqEnd += 1;
          if (nbReqEnd == 2) resolve()
        });
      }).then(() => {
        const frsGuidParam = new URL(window.location.href).searchParams.get("frsGuid");
        const yearParam = new URL(window.location.href).searchParams.get("year");

        if (frsGuidParam && this.frsList.find(el => el.Guid === frsGuidParam) != undefined) {
          this.selectedFrsGuid = frsGuidParam;
        }
        if (yearParam && this.yearList.find(el => el == yearParam)) {
          this.selectedYear = yearParam;
        } else {
          if (this.yearList.indexOf(2022) !== -1) this.selectedYear = 2022
          else this.selectedYear = Math.max(...this.yearList);
        }
      })
    },
    watch: {
      // Lorsque l'année change, on rafraichit la liste des fournisseurs présent sur la campagne
      selectedYear() {
        getFrsList(this.selectedYear === -1 ? null : this.selectedYear).then(res => this.frsList = res);
        this.getData();
      },
      selectedFrsGuid() {
        this.getData();
      }
    },
    computed: {
      // Récupère les données du founisseur à partir du Guid du fournisseur sélectionné (selectedFrsGuid)
      selectedFrs() {
        if (this.selectedFrsGuid) return this.frsList.find(el => el.Guid == this.selectedFrsGuid);
        return null;
      }
    },
    methods: {
      //Subtitution au fournisseur
      substitute(guid) {
        this.selectedFrsGuid = guid;
      },
      // Récupère les données nécessaires à la génération du fichier
      getData() {
        this.data = { N2: false }
        let displayedErrorMsg = false; // true si l'utilisateur a déjà été alerté qu'il manque des données pour n'afficher le msg qu'une fois
        if (this.selectedYear == -1 || this.selectedYear == 0 || !this.selectedFrsGuid || !this.selectedFrs) return;
        getFrsInfosByYear(this.selectedYear - 2, this.selectedFrsGuid).then(response => {
          if (!response.length > 0 && !displayedErrorMsg) {
            window.alert("Des données sont manquantes sur ce fournisseur");
            displayedErrorMsg = true;
          }

          let annuel = response.find(el => el.PeriodType === 3);
          if (!annuel) annuel = {
            Ca: 0,
            CaBrut: 0,
            RfaFixe: 0,
            RfaInd: 0,
            NbPdv: 0
          };
          this.data.CAN1 = annuel.Ca;
          this.data.CABrutN1 = annuel.CaBrut;
          this.data.RfaFixeN1 = annuel.RfaFixe;
          this.data.RfaIndN1 = annuel.RfaInd;
          this.data.NbPdvN1 = annuel.NbPdv;
        })

        getFrsInfosByYear(this.selectedYear - 3, this.selectedFrsGuid).then(response => {
          if (!response.length > 0 && !displayedErrorMsg) {
            window.alert("Des données sont manquantes sur ce fournisseur");
            displayedErrorMsg = true;
          }

          let annuel = response.find(el => el.PeriodType === 3);
          if (!annuel)
            annuel = {
            Ca: 0,
            CaBrut: 0,
            RfaFixe: 0,
            RfaInd: 0,
            NbPdv: 0
          };
          this.data.CAN2 = annuel.Ca;
          this.data.CABrutN2 = annuel.CaBrut;
          this.data.RfaFixeN2 = annuel.RfaFixe;
          this.data.RfaIndN2 = annuel.RfaInd;
          this.data.NbPdvN2 = annuel.NbPdv;
          this.data.N2 = true;
        })

        getFrsInfosByYear(this.selectedYear - 4, this.selectedFrsGuid).then(response => {
          if (!response.length > 0 && !displayedErrorMsg) {
            window.alert("Des données sont manquantes sur ce fournisseur");
            displayedErrorMsg = true;
          }

          let annuel = response.find(el => el.PeriodType === 3);
          if (!annuel) annuel = {
            Ca: 0,
            CaBrut: 0,
            RfaFixe: 0,
            RfaInd: 0,
            NbPdv: 0
          };
          this.data.CAN3 = annuel.Ca;
          this.data.CABrutN3 = annuel.CaBrut;
          this.data.RfaFixeN3 = annuel.RfaFixe;
          this.data.RfaIndN3 = annuel.RfaInd;
          this.data.NbPdvN3 = annuel.NbPdv;
        })

        getFrsLastContactUpdateDate(this.selectedFrsGuid).then(res => {
          this.data.lastContactUpdateDate = res;
        })

        getFrsIntranetRubriques(this.selectedFrsGuid).then(res => {
          this.data.rubriques = {}
          for (let obj of res) {
            this.data.rubriques[obj.Key] = obj.Value;
          }
        })

        getFrsIntranetDocumentLastDate(this.selectedFrsGuid, "AVIS DE HAUSSE", 3).then(res => {
          this.data.lastDocumentsDates = {};
          res.forEach((r, i) => {
            this.data.lastDocumentsDates[i + 1] = r;
          })
        });

        getFrsVersementsByYear(this.selectedFrsGuid, this.selectedYear - 1).then(res => {
          this.data.versements = res;
        })

        getFrsAppointmentFormData(this.selectedFrsGuid, this.selectedYear).then(res => {
          this.data.appointmentFormData = {};
          for (let key in res) {
            this.data.appointmentFormData[key] = res[key];
          }
        })
      },
      generateExcel() {
        if (!this.selectedFrs) return;
        fetch("/static/t.xlsx")
          .then((res) => res.blob())
          .then((data) => {
            const workbook = new ExcelJS.Workbook();
            workbook.xlsx.load(data).then((wb) => {
              const worksheet = wb.worksheets[0];
              this.fillWs(worksheet)
              this.saveWb(wb);
              logGeneratedFicheRdv(this.selectedFrsGuid, this.selectedYear);
            });
          })
      },
      // Remplit l'excel avec les données récupérées
      fillWs(ws) {
        const today = new Date();
        const formattedDate = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();
        // General

        ws.getCell("B4").value = "Fiche  RDV Fournisseurs " + (this.selectedYear)
        ws.getCell("C6").value = this.selectedFrs.Name;
        ws.getCell("C7").value = this.selectedFrs.RepresentativeFullName;
        ws.getCell("C8").value = this.selectedFrs.CdmFullName;
        ws.getCell("C9").value = this.data.appointmentFormData.CompanyCa;
        ws.getCell("K6").value = this.selectedFrs.IdCompta;
        ws.getCell("L6").value = this.selectedFrs.CodeIntranet;
        ws.getCell("K7").value = this.selectedFrs.N1Code;
        ws.getCell("J8").value = "Le : " + formattedDate;

        ws.getCell("K5").value = this.frsSimulableInfos[this.selectedFrs.Guid] ? "Oui" : "Non"

        // N - 1
        ws.getCell("D12").value = this.data.CAN1;
        ws.getCell("C37").value = this.data.CAN1;
        ws.getCell("G37").value = this.data.CABrutN1;
        ws.getCell("E37").value = this.data.appointmentFormData.FinalCaWithCmem;
        ws.getCell("G31").value = this.data.RfaFixeN1 / this.data.CAN1;
        ws.getCell("H31").value = this.data.RfaFixeN1;
        ws.getCell("G32").value = this.data.RfaIndN1 / this.data.CAN1;
        ws.getCell("H32").value = this.data.RfaIndN1;
        ws.getCell("C39").value = this.data.NbPdvN1;

        //if (!this.data.N2) return;

        // N - 2
        ws.getCell("D10").value = this.data.CAN2;
        ws.getCell("B37").value = this.data.CAN2;
        ws.getCell("G29").value = this.data.RfaFixeN2 / this.data.CAN2;
        ws.getCell("H29").value = this.data.RfaFixeN2;
        ws.getCell("G30").value = this.data.RfaIndN2 / this.data.CAN2;
        ws.getCell("H30").value = this.data.RfaIndN2;
        ws.getCell("B39").value = this.data.NbPdvN2;

        // RFA Moy
        const RfaFixeMoy = (this.data.RfaFixeN1 + this.data.RfaFixeN2 + this.data.RfaFixeN3) / (this.data.CAN1 + this.data.CAN2 + this.data.CAN3)
        ws.getCell("D39").value = RfaFixeMoy

        const RfaIndMoy = (this.data.RfaIndN1 + this.data.RfaIndN2 + this.data.RfaIndN3) / (this.data.CAN1 + this.data.CAN2 + this.data.CAN3)
        ws.getCell("E39").value = RfaIndMoy

        // Champs calculés
        ws.getCell("D37").value = {
          formula: ws.getCell("D37").value.formula,
          result: this.data.CAN1 / this.data.CAN2 - 1
        }
        ws.getCell("F37").value = {
          formula: ws.getCell("F37").value.formula,
          result: 1 / this.data.CAN1 - 1/*N estimé -> Remplacer le 1*/
        }
        ws.getCell("H37").value = {
          formula: ws.getCell("H37").value.formula,
          result: this.data.CAN1 / this.data.CABrutN1
        }

        //Situation RFA
        ws.getCell(this.data.versements.indexOf("Avril") === -1 ? "L13" : "K13").value = "O"
        ws.getCell(this.data.versements.indexOf("Juin") === -1 ? "L14" : "K14").value = "O"
        ws.getCell(this.data.versements.indexOf("Acompte") === -1 ? "L15" : "K15").value = "O"

        // Contact
        ws.getCell("L43").value = this.data.lastContactUpdateDate;

        // Rubriques
        ws.getCell("B43").value = 1;
        //ws.getCell("B43").value = this.data.rubriques.ProtCond ? "1" : "";
        ws.getCell("C43").value = this.data.rubriques.GrilleRemise ? "1" : "";
        ws.getCell("D43").value = this.data.rubriques.PourquoiMeChoisir ? "1" : "";
        //ws.getCell("E43").value = this.data.rubriques.SuiviCa ? "1" : "";
        ws.getCell("E43").value = 1;
        ws.getCell("F43").value = this.data.rubriques.Promotions ? "1" : "";
        ws.getCell("G43").value = this.data.rubriques.TarifBrut ? "1" : "";
        ws.getCell("I43").value = this.data.rubriques.TarifNetQuanti ? "1" : "";
        ws.getCell("J43").value = this.data.rubriques.TarifInfo ? "1" : "";
        ws.getCell("K43").value = this.data.rubriques.TarifCsv ? "1" : "";

        ws.getCell("B46").value = this.data.rubriques.AvisHausse ? "1" : "";
        //ws.getCell("C46").value = this.data.rubriques.ProtCond;
        ws.getCell("D46").value = this.data.lastDocumentsDates[1] ? this.data.lastDocumentsDates[1] : "/";
        ws.getCell("E46").value = this.data.lastDocumentsDates[2] ? this.data.lastDocumentsDates[2] : "/";
        ws.getCell("F46").value = this.data.lastDocumentsDates[3] ? this.data.lastDocumentsDates[3] : "/";
        ws.getCell("G46").value = this.data.rubriques.Documentation ? "1" : "";
        ws.getCell("I46").value = this.data.rubriques.OffresLs ? "1" : "";
        ws.getCell("J46").value = this.data.rubriques.Dop ? "1" : "";
        ws.getCell("K46").value = this.data.rubriques.AttestAssurance ? "1" : "";
        ws.getCell("L46").value = this.data.rubriques.CGV ? "1" : "";


        // AppointmentForm Data
        ws.getCell("G19").value = this.data.appointmentFormData.MarketSituation / 100;
        ws.getCell("G20").value = this.data.appointmentFormData.YourCompany / 100;
        ws.getCell("G21").value = this.data.appointmentFormData.WithCmem / 100;
        ws.getCell("G22").value = this.data.appointmentFormData.FinalCaWithCmem;
        ws.getCell("G23").value = this.data.appointmentFormData.FinalVolumeWithCmem;
        ws.getCell("G24").value = this.data.appointmentFormData.TargetCa;
        ws.getCell("G25").value = this.data.appointmentFormData.TargetVolume;
        ws.getCell("G26").value = this.data.appointmentFormData.PriceIncrease / 100;
        ws.getCell("G27").value = this.data.appointmentFormData.MarketPriceIncrease / 100;
        ws.getCell("G28").value = this.data.appointmentFormData.EstimatedMarketPriceIncrease / 100;

        ws.getCell("G33").value = this.data.appointmentFormData.EstimatedFixedRfaRateN / 100;
        ws.getCell("G34").value = this.data.appointmentFormData.EstimatedIndividualRfaRateN / 100;
        ws.getCell("H33").value = this.data.appointmentFormData.EstimatedFixedRfaN;
        ws.getCell("H34").value = this.data.appointmentFormData.EstimatedIndividualRfaN;

        ws.getCell("G35").value = this.data.appointmentFormData.FixedRateCommitment / 100;

        ws.getCell("L26").value = this.data.appointmentFormData.MadeInEuropeOutsideFrance / 100;
        ws.getCell("L27").value = this.data.appointmentFormData.MadeInFrance / 100;
        ws.getCell("L28").value = this.data.appointmentFormData.MadeOutOfEurope / 100;

        ws.getCell("L30").value = this.data.appointmentFormData.SpecificContractLineAndLight ? "O" : "";
        ws.getCell("L31").value = this.data.appointmentFormData.SpecificContractWoodalliance ? "O" : "";

        // Si on choisit l'option de la facturation affichée
        if (this.withFacturation) {
          ws.getCell(this.data.appointmentFormData.BdwParticipation ? "K19" : "L19").value = this.data.appointmentFormData.BdwParticipation
          ws.getCell(this.data.appointmentFormData.BdwSettledInvoice ? "K20" : "L20").value = this.data.appointmentFormData.BdwSettledInvoice

          ws.getCell(this.data.appointmentFormData.CmemConnectParticipation ? "K23" : "L23").value = this.data.appointmentFormData.CmemConnectParticipation
          ws.getCell(this.data.appointmentFormData.CmemConnectSettledInvoice ? "K24" : "L24").value = this.data.appointmentFormData.CmemConnectSettledInvoice

          ws.getCell(this.data.appointmentFormData.OdwParticipation ? "K34" : "L34").value = this.data.appointmentFormData.OdwParticipation
          ws.getCell(this.data.appointmentFormData.OdwSettledInvoice ? "K35" : "L35").value = this.data.appointmentFormData.OdwSettledInvoice
        }

        // Précurseur d'explosif
        ws.getCell("L40").value = this.data.appointmentFormData.ExplosivesPrecursors ? "Oui" : "Non";

        ws.getCell("C46").value = this.data.appointmentFormData.MarketPriceIncrease / 100;
        ws.getCell("B49").value = this.data.appointmentFormData.SupplierInformation;

        //Classification étoiles CMEM
        let score = 0;
        const af = this.data.appointmentFormData
        if (af.MadeInFrance >= 99) {
          ws.getCell("F52").value = 3;
          score += 3;
        }
        else if (af.MadeInFrance + af.MadeInEuropeOutsideFrance >= 99 && af.MadeInFrance > 0) {
          ws.getCell("I52").value = 2;
          score += 2;
        }
        else if (af.MadeInEuropeOutsideFrance >= 99) {
          ws.getCell("L52").value = 1;
          score += 1;
        }
        else {
          ws.getCell("I52").value = 1;
          score += 1;
        }

        if (af.HasStandards) score += 1;
        ws.getCell("F53").value = af.HasStandards ? 1 : 0;

        if (af.HasRseReport) score += 1;
        ws.getCell("I53").value = af.HasRseReport ? 1 : 0;

        if (af.HasWasteManagementSolution) score += 1;
        ws.getCell("L53").value = af.HasWasteManagementSolution ? 1 : 0;

        if (af.HasInnovationInfo) score += 1;
        ws.getCell("F54").value = af.HasInnovationInfo ? 1 : 0;

        if (af.FdesIntegrated) score += 1;
        ws.getCell("I54").value = af.FdesIntegrated ? 1 : 0;

        if (af.HasGreenProductLabel) score += 1;
        ws.getCell("L54").value = af.HasGreenProductLabel ? 1 : 0;

        if (af.HasEcovadisNote) score += 1;
        ws.getCell("F55").value = af.HasEcovadisNote ? 1 : 0;

        if (af.HasCarbonFootPrint) score += 1;
        ws.getCell("I55").value = af.HasCarbonFootPrint ? 1 : 0;

        if (af.HasSupplierIndex) score += 1;
        ws.getCell("L55").value = af.HasSupplierIndex ? 1 : 0;

        ws.getCell("J51").value = score;
        let indicator = "E";
        if (score >= 12) indicator = "A+";
        else if (score >= 9) indicator = "A";
        else if (score >= 6) indicator = "B";
        else if (score >= 3) indicator = "C";
        else if (score >= 1) indicator = "D";
        else indicator = "E";

        ws.getCell("K51").value = indicator;
      },
      // Télécharge le fichier excel
      saveWb(wb) {
        wb.xlsx.writeBuffer().then((data) => {
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          saveAs(blob, this.selectedFrs.Name + " " + this.selectedYear + ".xlsx");
        })
      }
    }
  }
</script>

<style scoped>
  #fiche-cdm-filter-container {
    width: 30%;
    border-bottom: 1px solid #C3C3C3;
    padding-bottom: 12px;
  }

  #fiche-cdm-filter-container > div {
      margin-bottom: 10px;
  }

   #fiche-cdm-content {
      width: 30%;
   }

  .button-generation {
      margin-top: 15px;
      width: 100%;
      background-color: #A7C13C;
      color: #FFFFFF;
      border: solid 1px #96ae36;
  }

  .button-generation:hover {
      background-color: #b0c84e;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Achat/FicheFrs.vue